import {
  HivebriteSegmentType,
} from '…/app/w/workspace/audiences/audience/members/hivebrite/types.js';

import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import SYNC_INTEGRATION_MEMBERS from './syncIntegrationMembers.gql';

type SyncIntegrationMembersResult = {
  syncIntegrationMembers: {
    displayName: string,
    jobRunId: string,
    // progress: number,
    status: string,
  },
};

export function syncIntegrationMembers(
  audienceId: string,
  integrationId: string,
  listIds: string[],
  listType: HivebriteSegmentType,
) {
  return gqlOperation<SyncIntegrationMembersResult>(SYNC_INTEGRATION_MEMBERS, {
    audienceId,
    integrationId,
    listIds,
    listType: listType.toUpperCase(),
  })
    .then((data) => {
      if (!data) throw data;
      return data.syncIntegrationMembers;
    });
}

